<template>
  <FontAwesomeIcon :icon="iconProp" class="fa-icon" />
</template>

<script>
export default {
  props: {
    /**
     * The icon to display (unless you want a brand icon)
     * See https://fontawesome.com/icons?d=gallery&m=free for all possible icons
     */
    icon: {
      type: String,
      default: undefined,
    },

    /**
     * The brand icon to display
     * See https://fontawesome.com/icons?d=gallery&s=brands&m=free for all possible icons
     */
    brand: {
      type: String,
      default: undefined,
    },

    /**
     * When displaying a non-brand icon it's possible to set the type to either 'regular' or 'solid'.
     * Solid is the default.
     */
    type: {
      type: String,
      default() {
        return 'solid'
      },
      validator(value) {
        return ['regular', 'solid', 'light'].includes(value)
      },
    },
  },

  computed: {
    /**
     * The name of the icon to display. Extracted from either the icon or the brand property.
     * @returns {string}
     */
    iconName() {
      return this.icon || this.brand
    },

    /**
     * Returns the icon properties needed by the official Font Awesome icon component.
     * @returns {[string, string]}
     */
    iconProp() {
      return [this.iconPrefix, this.iconName]
    },

    /**
     * Returns the prefix for the icon based on the given properties.
     * @returns {string}
     */
    iconPrefix() {
      if (this.brand) {
        return 'fab'
      }

      switch (this.type) {
        case 'solid':
          return 'fas'
        case 'light':
          return 'fal'
        default:
          return 'far'
      }
    },
  },
}
</script>

<style lang="scss">
$iconSize: 1em;

:root {
  --fa-icon-size: #{$iconSize};
}

.fa-icon {
  display: inline-block;
  font-size: var(--fa-icon-size, $iconSize);
  width: 1em;
  height: 1em;
  vertical-align: -0.125em;
  color: inherit;

  * {
    // Setting color inherit on all icon children, since this is all SVG stuff,
    // and some global FESSOR style was overriding desired text color.
    color: inherit;
  }
}
</style>
